import screens from "@/config/screens.json";

export function header() {
    return {
        // sticky header state
        stickyState: 'top',
        lastScrollY: 0,
        totalMovement: 0,
        _raf: null,
        _scrollHandler: null,

        // nav state
        menuOpen: false,
        searchOpen: false,
        openSection: null,
        lockTransition: false,
        locked: false,
        _openTimer: null,
        _closeTimer: null,
        _lockTimer: null,

        // ----------------------------------------------------------------
        // Lifecycle
        // ----------------------------------------------------------------
        init() {
            this._scrollHandler = () => this._onScroll();
            window.addEventListener('scroll', this._scrollHandler, { passive: true });
            this._onScroll();

            this.$watch('menuOpen', value => value ? this.lock() : this.unlock());
            this.$watch('searchOpen', value => value ? this.lock() : this.unlock());
        },

        destroy() {
            window.removeEventListener('scroll', this._scrollHandler);
            cancelAnimationFrame(this._raf);
            clearTimeout(this._openTimer);
            clearTimeout(this._closeTimer);
            clearTimeout(this._lockTimer);
        },

        // ----------------------------------------------------------------
        // Sticky / scroll
        // ----------------------------------------------------------------
        _onScroll() {
            const delta = window.pageYOffset - this.lastScrollY;
            this.totalMovement = Math.min(400, Math.max(0, this.totalMovement + delta));
            this.lastScrollY = Math.max(0, window.pageYOffset);
            cancelAnimationFrame(this._raf);
            this._raf = requestAnimationFrame(() => this._paint());
        },

        _paint() {
            if (this.locked) return;

            const y = -0.5 * this.totalMovement;
            this.$el.style.transform = `translateY(${y}px)`;

            const isMd = window.matchMedia(`(min-width: ${screens.sm.min})`).matches;
            this.stickyState = (window.pageYOffset > 200 && isMd) ? 'stuck' : 'top';

            const headerBottom = Math.max(0, this.$el.getBoundingClientRect().bottom);
            document.querySelectorAll('.sticky').forEach(el => {
                el.style.top = `${headerBottom}px`;
            });
        },

        lock() {
            this.locked = true;
        },

        unlock() {
            this.locked = false;
            this._paint();
        },

        // ----------------------------------------------------------------
        // Hamburger (mobile menu)
        // ----------------------------------------------------------------
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },

        // ----------------------------------------------------------------
        // Search
        // ----------------------------------------------------------------
        toggleSearch() {
            this.searchOpen = !this.searchOpen;
            if (this.searchOpen && document.documentElement.getAttribute('data-whatinput') === 'mouse') {
                this.$nextTick(() => this.$refs.searchInput?.focus());
            }
        },

        // ----------------------------------------------------------------
        // Nav shelves
        // ----------------------------------------------------------------
        isOpen(i) {
            return this.openSection === i;
        },

        openShelf(i) {
            this.openSection = i;
            clearTimeout(this._lockTimer);
            this._lockTimer = setTimeout(() => { this.lockTransition = true; }, 50);
        },

        closeShelf() {
            this.openSection = null;
            clearTimeout(this._lockTimer);
            this.lockTransition = false;
        },

        startOpen(i) {
            clearTimeout(this._closeTimer);
            clearTimeout(this._openTimer);
            this._openTimer = setTimeout(() => this.openShelf(i), 500);
        },

        startClose(i) {
            clearTimeout(this._openTimer);
            clearTimeout(this._closeTimer);
            this._closeTimer = setTimeout(() => {
                if (this.isOpen(i)) this.closeShelf();
            }, 250);
        },

        toggle(i) {
            this.isOpen(i) ? this.closeShelf() : this.openShelf(i);
        },
    };
}
